// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WatchLater: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M21,0.17C9.54,0.17,0.17,9.54,0.17,21c0,11.46,9.38,20.83,20.83,20.83
	S41.83,32.46,41.83,21C41.83,9.54,32.46,0.17,21,0.17z M29.75,29.75l-10.83-6.67v-12.5h3.12v10.83l9.38,5.62L29.75,29.75z"/>
</svg>;
};

export default React.memo(WatchLater);
